import api from './_api';
import Vue from 'vue'


const postForm= async (context,payload) => {    
    let result=payload.payload
    let id=payload.id   
    result.entity_id = payload.parent_id
    
    try{        
        var response = await api.postForm(result,id)
        if (response) {                                         
            await context.dispatch('getAll');
            //alert(JSON.stringify(result))
            context.commit('RECIPESTEP_SET_FORRECIPE', result.entity_id)
            context.commit('RECIPESTEP_SET_DUPLICATE', false)
            return response
        }
    }
    catch(error)  {              
        return Promise.reject(error);
    };    
};
        
const getAll = async (context) => {
    
    try {        
        var response = await api.fetchAll()                
        context.commit('RECIPESTEP_SET_RECIPESTEPS',response.data)         
        return response.data
    }
    catch(error) {                        
        return Promise.reject(error);
    };    
};


const getById = async (context,payload) => {
    try {        
        var response = await api.getById(payload)                
        context.commit('RECIPESTEP_SET_RECIPESTEP',response.data)           
        return response.data
    }
    catch(error) {                        
        return Promise.reject(error);
    };    
};

const deleteById = async (context,payload) => {
    
    try {              
        var response = await api.deleteById(payload.item_id)     
        await context.dispatch('getAll')           
        context.commit('RECIPESTEP_SET_FORRECIPE', payload.parent_id)
        return response.data
    }
    catch(error) {   
        //alert(error)                          
        return Promise.reject(error);
    };    
};



export default {
  getAll,
  postForm,
  getById,
  deleteById,
  
};
